import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '@/lib/api';

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/site/pages/${slug}`).then(r => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <div className="py-24 text-center">Page not found. <Link to="/" className="text-royal underline">Home</Link></div>;
  if (!page) return <div className="py-24 text-center">Loading…</div>;
  return (
    <div>
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0">{page.hero_image && <img src={page.hero_image} alt="" className="w-full h-full object-cover" />}<div className="absolute inset-0 bg-royal/80" /></div>
        <div className="relative max-w-4xl mx-auto px-6 text-white text-center">
          {page.overline && <div className="overline text-gold mb-4">{page.overline}</div>}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold">{page.title}</h1>
          {page.subtitle && <p className="mt-6 text-white/85 text-lg">{page.subtitle}</p>}
        </div>
      </section>
      <section className="bg-white py-20">
        <div className="max-w-3xl mx-auto px-6 prose prose-lg" style={{ whiteSpace: 'pre-wrap' }}>
          <div className="text-charcoal-muted leading-relaxed text-lg">{page.body}</div>
        </div>
      </section>
    </div>
  );
}
